import {
  LOGOUT,
  API_SUCCESS,
  API_ERROR,
  USER_OFFLINE_SUCCESS,
} from "../actions/actionTypes";

function getLoginResponse() {
  let rawLoginData = localStorage.getItem("loginResponse");
  let loginData = null;
  if (rawLoginData) {
    loginData = JSON.parse(rawLoginData);
  }
  return loginData;
}
export function getUserName() {
  let loginResponse = getLoginResponse();
  let userName;
  if (loginResponse && loginResponse.hasOwnProperty("user_full_name")) {
    userName = loginResponse.user_full_name;
  }
  return userName;
}

function getUser() {
  const loginResponse = getLoginResponse();
  let username;
  if (loginResponse && loginResponse.hasOwnProperty("username")) {
    username = loginResponse.username;
  }

  return username;
}

export const isTestUser = function (testValue) {
  if (testValue === "PRODUCTION" || testValue === "PROD") {
    return false;
  }
  return true;
};
export function getClientId() {
  let loginResponse = getLoginResponse();
  let clientId;
  if (loginResponse && loginResponse.hasOwnProperty("client_id")) {
    clientId = loginResponse.client_id;
  }
  return clientId;
}
function getUserAppStatus() {
  let loginResponse = getLoginResponse();
  let user_app_status;
  if (loginResponse && loginResponse.hasOwnProperty("user_app_status")) {
    user_app_status = loginResponse.user_app_status;
  }
  return user_app_status;
}
function getToken() {
  let loginResponse = getLoginResponse();
  let token;
  if (loginResponse && loginResponse.hasOwnProperty("token")) {
    token = loginResponse.token;
  }
  return token;
}
function getTokenExpiration() {
  let loginResponse = getLoginResponse();
  let token_expires;
  if (loginResponse && loginResponse.hasOwnProperty("token_expires")) {
    token_expires = loginResponse.token_expires;
  }
  return token_expires;
}
function getOperatorKey() {
  let loginResponse = getLoginResponse();
  let operatorKey = 0;
  if (loginResponse && loginResponse.hasOwnProperty("operator_key")) {
    operatorKey = loginResponse.operator_key;
  }
  return operatorKey;
}

function getOperatorEntitlements(operatorValue) {
  //TODO change to look through the entitlements array when api is changed
  let loginResponse = getLoginResponse();
  let operatorKey = [];
  if (operatorValue && operatorValue !== 0) {
    console.log(operatorValue);
    operatorKey[0] = operatorValue;
  }
  if (
    loginResponse &&
    loginResponse.hasOwnProperty("operator_key") &&
    loginResponse.operator_key !== 0
  ) {
    operatorKey[0] = loginResponse.operator_key;
  }
  return operatorKey;
}

function getVesselEntitlements(entitlements) {
  let loginResponse = getLoginResponse();
  let vesselEntitlements = [];
  if (entitlements) {
    for (let e = 0; e < entitlements.length; e++) {
      if (entitlements[e].hasOwnProperty("vessel")) {
        vesselEntitlements[vesselEntitlements.length] = entitlements[e].vessel;
      }
    }
  } else {
    if (
      loginResponse &&
      loginResponse.hasOwnProperty("entitlements") &&
      loginResponse.entitlements.length > 0
    ) {
      let entitlements = loginResponse.entitlements;
      for (let e = 0; e < entitlements.length; e++) {
        if (entitlements[e].hasOwnProperty("vessel")) {
          vesselEntitlements[vesselEntitlements.length] = entitlements[e].vessel;
        }
      }
    }
  }
  return vesselEntitlements;
}

function getEntitlements() {
  let loginResponse = getLoginResponse();
  let entitlements = [];
  if (loginResponse && loginResponse.hasOwnProperty("entitlements")) {
    entitlements = loginResponse.entitlements;
  }
  return entitlements;
}

function getVtrPreferences() {
  let loginResponse = getLoginResponse();
  let vtrPreferences = [];
  if (loginResponse && loginResponse.hasOwnProperty("vtr_preferences")) {
    vtrPreferences = loginResponse.vtr_preferences;
  }
  return vtrPreferences;
}
export default function rootReducer(
  state = {
    isAuthUser: !!localStorage.getItem("user"),
    client_id: getClientId(),
    user_full_name: getUserName(),
    token: getToken(),
    token_expires: getTokenExpiration(),
    user_app_status: getUserAppStatus(),
    vessel_entitlements: getVesselEntitlements(),
    operator_entitlements: getOperatorEntitlements(),
    // entitlements when API changes
    entitlements: getEntitlements(), //TODO split up in operator
    // entitlement and vessel entitlements
    operator_key: getOperatorKey(), //Todo this can be dropped when split
    // entitlements
    vtr_preferences: getVtrPreferences(),
    error: null,
    username: getUser(),
    validations: {},
    redirect: false,
  },
  action
) {
  switch (action.type) {
    case API_SUCCESS:
      state.isAuthUser = true;
      state.error = null;
      state.client_id = action.payload.client_id;
      state.user_full_name = action.payload.user_full_name;
      state.user_app_status = action.payload.user_app_status;
      state.token = action.payload.token;
      state.token_expires = action.payload.token_expires;
      state.operator_key = action.payload.operator_key;
      state.operator_entitlements = getOperatorEntitlements(action.payload.operator_key);
      state.vessel_entitlements = getVesselEntitlements(action.payload.entitlements);
      state.entitlements = action.payload.entitlements;
      state.vtr_preferences = action.payload.vtr_preferences;
      state.username = action.payload.username;
      return { ...state };
    case API_ERROR:
      state.isAuthUser = false;
      return { ...state };
    case LOGOUT:
      localStorage.removeItem("user");
      localStorage.removeItem("loginResponse");
      state.isAuthUser = false;
      state.client_id = null;
      state.user_full_name = null;
      state.username = null;
      state.user_app_status = null;
      state.token = null;
      state.token_expires = null;
      state.operator_key = 0;
      state.operator_entitlements = [];
      state.vessel_entitlements = [];
      state.entitlements = [];
      state.vtr_preferences = [];
      return { ...state };
    case USER_OFFLINE_SUCCESS:
      state.isAuthUser = true;
      state.error = null;
      state.client_id = action.payload.client_id;
      state.user_full_name = action.payload.user_full_name;
      state.user_app_status = action.payload.user_app_status;
      state.username = action.payload.username;
      state.operator_key = action.payload.operator_key;
      state.entitlements = action.payload.entitlements;
      state.validations = action.validationsPayload;
      state.token_expires = Math.floor((Date.now() - 1 * 60 * 60 * 1000) / 1000);
      state.vtr_preferences = action.payload.vtr_preferences;
      return { ...state };
    default:
      return state;
  }
}
